import { Box } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import { toDataCy } from "lib/to-data-cy"

export function Classification({ classification, children, boxSx = {} }) {
    return (
        <Box
            data-cy={toDataCy("classification-state", classification)}
            className={`classification ${classification}`}
            display="inline-flex"
            alignItems="center"
            sx={{ lineHeight: 0, ...boxSx }}
        >
            <Box>
                <Iconify
                    sx={{
                        color: COLOR_FROM_CLASSIFICATION[classification],
                        width: 24,
                        height: 24,
                        flexShrink: 0,
                    }}
                    icon={ICON_FROM_CLASSIFICATION[classification]}
                    data-cy="classification-icon"
                    aria-label={`Classification: ${classification}`}
                    aria-hidden={false}
                />
            </Box>
            {children}
        </Box>
    )
}
